import ModalHeader from "../ModalHeader";
import Buttons from "./buttons/Buttons";
import ModalDateField from './inputs/ModalDateField';
import ModalCheckbox from "./inputs/ModalCheckbox";
import CustomMultiline from "../../../../survey/components/inputs/CustomMultiline";
import { Typography } from "@mui/material";
import { useState } from "react";
import { useEditAssignmentMutation } from "../../../../../services/AssignmentApi";

// Convert date from "MM/DD/YYYY" to "YYYY-MM-DD"
const convertDate = (date) => {
  const splitDate = date.split('/');
  const year = splitDate[2];
  const month = splitDate[0];
  const day = splitDate[1];
  return `${year}-${month}-${day}`;
}

// Convert date from "YYYY-MM-DD" to "MM/DD/YYYY"
const convertDateToReadable = (date) => {
  const splitDate = date.split('-');
  const year = splitDate[0];
  const month = splitDate[1];
  const day = splitDate[2];
  return `${month}/${day}/${year}`;
}

export default function EditAssignmentModal({handleClose, assignment, crews, setCrews, crew, setAlertMessage}) {
  const [editAssignment] = useEditAssignmentMutation();
  const [startDate, setStartDate] = useState(assignment?.['47'] ? convertDate(assignment?.['47']) : '');
  const [endDate, setEndDate] = useState(assignment?.['48'] ? convertDate(assignment?.['48']) : '');
  const [siteContactNotified, setSiteContactNotified] = useState(assignment?.['128']);
  const [siteContactReplied, setSiteContactReplied] = useState(assignment?.['129']);
  const [pendingApproval, setPendingApproval] = useState(assignment?.['173']);
  const [schedulingNotes, setSchedulingNotes] = useState(assignment?.['187']);

  return (
    <div 
      className='flex flex-col w-full h-full pb-2'
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
        <ModalHeader handleClose={handleClose} message={`Assignment #${assignment?.['46']}`} />

        <div className="flex flex-col px-6 pt-4">

          <div className="mt-2 flex flex-col items-start">
            <Typography sx={{fontSize: "12px", color: "rgb(51, 51, 51)", mr: "1rem"}}>Start date</Typography>
            <ModalDateField 
                value={startDate}
                handleChange={(e) => {
                  setStartDate(e.target.value);
                }}
            />
          </div>

          <div className="mt-2 flex flex-col items-start">
            <Typography sx={{fontSize: "12px", color: "rgb(51, 51, 51)", mr: "1rem"}}>End date</Typography>
            <ModalDateField 
                value={endDate} 
                handleChange={(e) => {
                  setEndDate(e.target.value);
                }}
            />
          </div>

          <div className="mt-2 flex flex-col items-start">
            <Typography sx={{fontSize: "12px", color: "rgb(51, 51, 51)", mr: "1rem"}}>Scheduling Notes</Typography>
            <CustomMultiline
              minRows={3}
              placeholder="Notes"
              value={schedulingNotes}
              onChange={(event) => {
                  setSchedulingNotes(event.target.value);
              }}
            />
          </div>

          <div className="mt-2 flex flex-row items-center">
            <ModalCheckbox 
                value={siteContactNotified ?? false} 
                handleChange={(e) => {
                  setSiteContactNotified(e.target.checked);
                }}
            />
            <Typography sx={{fontSize: "12px", color: "rgb(51, 51, 51)", ml: "0.5rem"}}>Site contact contacted</Typography>
          </div>

          <div className="mt-2 flex flex-row items-center">
            <ModalCheckbox 
                value={siteContactReplied ?? false} 
                handleChange={(e) => {
                  setSiteContactReplied(e.target.checked);
                }}
            />
            <Typography sx={{fontSize: "12px", color: "rgb(51, 51, 51)", ml: "0.5rem"}}>Site contact replied</Typography>
          </div>

          <div className="mt-2 flex flex-row items-center">
            <ModalCheckbox 
                value={pendingApproval ?? false} 
                handleChange={(e) => {
                  setPendingApproval(e.target.checked);
                }}
            />
            <Typography sx={{fontSize: "12px", color: "rgb(51, 51, 51)", ml: "0.5rem"}}>Pending approval</Typography>
          </div>

        </div>

        <Buttons 
          handleClose={handleClose}
          submit={() => {
            editAssignment({
                id: assignment?.['3'],
                data: {'start_date': startDate, 'end_date': endDate, 'crew_manager': assignment?.['60'], 'site_contact_notified': siteContactNotified, 'site_contact_replied': siteContactReplied, 'pending_approval': pendingApproval, 'scheduling_notes': schedulingNotes, 'sr_crew_manager': assignment?.['189']}
            })
            .unwrap()
            .then((res) => {
                console.log(res);
                const newAssignment = {...assignment};
                newAssignment['47'] = startDate === '' ? '' : convertDateToReadable(startDate);
                newAssignment['48'] = endDate === '' ? '' : convertDateToReadable(endDate);
                newAssignment['128'] = siteContactNotified;
                newAssignment['129'] = siteContactReplied;
                newAssignment['173'] = pendingApproval;
                newAssignment['187'] = schedulingNotes;

                // Update the assignment in the run
                const updatedCrew = {...crew};
                const updatedAssignments = [...updatedCrew['assignments']];
                const index = updatedAssignments.findIndex((assignment) => assignment['3'] === newAssignment['3']);
                updatedAssignments[index] = newAssignment;
                updatedCrew['assignments'] = updatedAssignments;
                
                // Update the crew in the crews state
                const newCrews = [...crews];
                const crewIndex = newCrews.findIndex((crew) => crew['3'] === updatedCrew['3']);
                newCrews[crewIndex] = updatedCrew;
                
                // Update the crews state
                setCrews(newCrews);
                setAlertMessage('Assignment updated successfully!');
                handleClose();
            })
            .catch((err) => {
                console.log(err);
            })
        }}
        />
    </div>
  );
}